export class ExitMeetingPageController {
    /*@ngInject*/
    constructor() {
    }
    $onInit() {
        this.$stateParams = this.$transition$.params();
    }
}
// import * as TEMPLATE from './exit-meeting-page.html';
import * as TEMPLATE from 'raw-loader!./exit-meeting-page.html';
export const ExitMeetingPageComponent = {
    selector: 'exitMeetingPage',
    component: {
        bindings: { $transition$: '<' },
        // templateUrl: 'app/partials/exitMeeting/exit-meeting-page.html',
        template: TEMPLATE.default,
        controller: ExitMeetingPageController
    }
};
//# sourceMappingURL=exit-meeting-page.component.js.map